import { AutoCompleteOption } from "../AutoComplete";
import { MenuTreeItem } from "./types";

export const getArrayFromTree = (data: MenuTreeItem[]) => {
  const itens: AutoCompleteOption[] = [];

  const group = (data: MenuTreeItem[]) => {
    data.forEach((item) => {
      const itemOption = { label: item.name, id: item.id };

      itens.push(itemOption);

      if (item.children) {
        group(item.children);
      }
    });
  };
  group(data);
  return itens;
};

export const getParents = (
  items: MenuTreeItem[],
  selectedId: string
): { parentsItems: MenuTreeItem[]; parentsIds: string[] } => {
  const ids: string[] = [];

  const getNodes = (result: MenuTreeItem[], object: MenuTreeItem): MenuTreeItem[] => {
    if (object.id === selectedId) {
      return [...result, object];
    }
    if (Array.isArray(object.children)) {
      const nodes = object.children.reduce(getNodes, []);
      if (nodes.length > 0) {
        ids.push(object.id as string);
        return [...result, { ...object, children: nodes }];
      }
    }
    return result;
  };

  return { parentsItems: items.reduce(getNodes, []), parentsIds: ids };
};
